<template>
  <div class="header">
    <div v-show="tabFlag" class="overlayer"></div>

    <div class="top">
      <div class="logo" :style="{ 'background': 'url(' + logo + ') no-repeat center', 'background-size': 'cover'}"></div>
      <div v-show="!tabFlag" class="tab" :style="{ 'background': 'url(' + tab + ') no-repeat center', 'background-size': '0.34rem 0.34rem'}" @click="clickTab"></div>
      <div v-show="tabFlag" class="close" :style="{ 'background': 'url(' + close + ') no-repeat center', 'background-size': '0.34rem 0.34rem'}" @click="clickClose"></div>

      <ul  v-if="tabFlag" class="menus">
        <li @click="clickLi('mHome')">
          <img :src="home"/>
          <p>首页</p>
        </li>
        <!-- <li @click="clickLi('mTechnology_Services')">
          <img :src="technologyService"/>
          <p>技术与服务</p>
        </li> -->
        <li @click="clickLi('mBig_Data')">
          <img :src="bigData"/>
          <p>保险行业赋能</p>
        </li>
        <li @click="clickLi('mAbout_Us')">
          <img :src="aboutUs"/>
          <p>关于我们</p>
        </li>
        <li @click="clickLi('mContact_Us')">
          <img :src="contactUs"/>
          <p>联系我们</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    data() {
      return {
        logo: require("@/assets/imgs/mobile/logo.png"),
        tab: require("@/assets/imgs/mobile/ic-tab.png"),
        close: require("@/assets/imgs/mobile/ic-tab-close.png"),
        home: require("@/assets/imgs/mobile/ic-tab-home.png"),
        technologyService: require("@/assets/imgs/mobile/ic-tab-technology-service.png"),
        bigData: require("@/assets/imgs/mobile/ic-tab-big-data.png"),
        aboutUs: require("@/assets/imgs/mobile/ic-tab-about-us.png"),
        contactUs: require("@/assets/imgs/mobile/ic-tab-contact-us.png"),

        tabFlag: false,
      }
    },
    methods: {
      clickTab() {
        this.tabFlag = !this.tabFlag
      },
      clickClose() {
        this.tabFlag = !this.tabFlag
      },
      clickLi(name) {
        this.tabFlag = !this.tabFlag
        this.$router.push(name).catch(err => err)
      }
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
  .overlayer {
    position:fixed;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    opacity: 1;
    z-index: 1200;
  }

  .top {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1201;
    height: 0.8rem;
    background:linear-gradient(0deg,rgba(0,0,0,0),rgba(0,0,0,1));
    &.active {
      background-color: #000;
    }
    .logo {
      width: 1.4rem;
      height: 0.36rem;
      margin: 0.22rem 0 0 0.3rem;
      display: inline-block;
      float: left;
    }
    .tab,.close {
      width: 0.8rem;
      height: 0.8rem;
      margin: 0 0.07rem 0 0;
      display: inline-block;
      float: right;
      background-size: 0.34rem 0.34rem
    }
    .menus {
      width: 100%;
      height: 3.6rem;background:rgba(255,255,255,1);
      margin-top: 0.8rem;
      box-sizing: border-box;
      -webkit-animation-name: fadeIn;
      -webkit-animation-timing-function: ease-in;
      -webkit-animation-duration: 0.3s;
      -webkit-animation-direction: alternate;

      li {
        width: 33.33%;
        text-align: center;
        float: left;
        padding: 0.6rem 0 0;
        box-sizing: border-box;
        img {
          width: 0.53rem;
          height: 0.53rem;
          display: block;
          margin: 0 auto;
        }
        p {
          font-size:0.26rem;
          line-height: 0.66rem;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(0,0,0,1);
        }
      }
    }
  }

  @-webkit-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/mComponents/Header.vue